"use strict";

exports.__esModule = true;
exports.claimPromo = void 0;
/* eslint-disable import/prefer-default-export */

var claimPromo = function claimPromo(ctaId, position) {
  return {
    type: 'CLAIM_PROMO',
    ctaId: ctaId,
    position: position
  };
};
exports.claimPromo = claimPromo;